import { render } from "./IconElectraFork.vue?vue&type=template&id=0fe35327"
import script from "./IconElectraFork.vue?vue&type=script&lang=js"
export * from "./IconElectraFork.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__